import { useEffect } from "react";

import type { AuditHistoryViewModelState } from "./useAuditHistoryViewModel";

export function useAuditHistoryLoader(
  vm: Pick<AuditHistoryViewModelState, "getAudits">,
  enabled: boolean,
) {
  useEffect(() => {
    if (enabled) vm.getAudits();
  }, [enabled, vm.getAudits]);
}
